import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO,
    CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelAnimalCategoriaCadastroRapido() {
  yield put({ type: CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelAnimalCategoriaCadastroRapido() {
  yield takeLatest(CANCEL_ANIMAL_CATEGORIA_CADASTRO_RAPIDO, sagaCancelAnimalCategoriaCadastroRapido)
}